import React from 'react'
import Address from "../../Components/Address/Address.jsx"
import "./WidgetsWeb.scss"
import icone from "../../Assets/icoone.png"
import arrow from "../../Assets/smallarrow.png"
import Widgetscharts from "../../Components/Widgetscharts/Widgetscharts.jsx"
import Piechart from "../../Components/Ui/Piechart.jsx"
import HorizontalBarChart from "../../Components/horizontal-bar-chart.jsx"
import chart from "../../Assets/linechart.png"
import lines from "../../Assets/lines.png"

export default function WidgetsWeb() {
  return (
    <div className='p-3'>
      <Address title="chart Graphs Web" />

      {/* أول صف من الكروت */}
      <div className='mt-3 cards-wrapper'>
        {/* الكارت الأيسر */}
        <div className='left-card d-flex justify-content-center align-items-center'>
          <div className='me-4 pe-4'>
            <div className='d-flex gap-4'>
              <span>Today's visitors</span>
              <img src={icone} width={30} height={30} alt="" />
            </div>
            <div className='d-flex gap-4 align-items-center mt-2'>
              <h3>6,777</h3>
              <span>-0.03% <img src={arrow} width={20} height={20} alt="" /></span>
            </div>
          </div>
          <div className='vr-line'></div>
          <div className='ms-4 ps-4'>
            <div className='d-flex gap-4'>
              <span>Today's visitors</span>
            </div>
            <div className='d-flex gap-4 align-items-center mt-2'>
              <h3>6,777</h3>
              <span>-0.03% <img src={arrow} width={20} height={20} alt="" /></span>
            </div>
          </div>
        </div>

        {/* الكارت الأيمن */}
        <div className='right-card d-flex justify-content-center align-items-center'>
          <div className='me-4 pe-4'>
            <div className='d-flex gap-4'>
              <span>Today's visitors</span>
              <img src={icone} width={30} height={30} alt="" />
            </div>
            <div className='d-flex gap-4 align-items-center mt-2'>
              <h3>6,777</h3>
              <span>-0.03% <img src={arrow} width={20} height={20} alt="" /></span>
            </div>
          </div>
          <div className='vr-line'></div>
          <div className='ms-4 ps-4'>
            <div className='d-flex gap-4'>
              <span>Today's visitors</span>
            </div>
            <div className='d-flex gap-4 align-items-center mt-2'>
              <h3>6,777</h3>
              <span>-0.03% <img src={arrow} width={20} height={20} alt="" /></span>
            </div>
          </div>
        </div>
      </div>

      {/* الجزء الثاني */}
      <div className="second-part mt-3">
        <div className="d-flex justify-content-center align-items-center w-100">
          <img src={chart} alt="Chart" className="img-fluid" />
        </div>
        <div className='w-100'>
          <div className="sidee-card p-3">
            <h4 className="mb-4">Traffic by Website</h4>
            <ul className='unstyle-list'>
              {["Google", "YouTube", "Instagram", "Telegram", "Facebook", "Twitter"].map((site, i) => (
                <div key={i} className='d-flex align-items-center gap-5 mb-2'>
                  <li>{site}</li>
                  <img src={lines} width={100} alt="" />
                </div>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* الجزء الثالث */}
      <div className='second-part mt-3'>
        <div className="chart-card  w-100">
          <h2 className="mb-4">Traffic by Location</h2>
          <div className="d-flex align-items-center justify-content-between gap-4">
            <div><Piechart /></div>
            <ul className="list-unstyled w-50">
              <li className="d-flex justify-content-between align-items-center mb-2">
                <span>Egypt</span><span>38.6%</span>
              </li>
              <li className="d-flex justify-content-between align-items-center mb-2">
                <span>Morocco</span><span>24.3%</span>
              </li>
              <li className="d-flex justify-content-between align-items-center mb-2">
                <span>Saudi Arabia</span><span>20.5%</span>
              </li>
              <li className="d-flex justify-content-between align-items-center mb-2">
                <span>Other</span><span>16.6%</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="chart-card w-100">
          <HorizontalBarChart />
        </div>
      </div>
    </div>
  )
}
